export default "<button class=\"float-btn w-100\">{{ title }}</button>\n";